




























import { Component, Prop, Vue } from 'vue-property-decorator';
import CloseIcon from '@/assets/icons/close.svg';
import CustomWindow from '@/types/CustomWindow';

@Component({
    components: {
        CloseIcon,
    },
})
export default class MarkerDetails extends Vue {
    public isSmall = true;

    @Prop({ type: String, required: true })
    title!: string;

    @Prop({ type: String, required: true })
    category!: string;

    @Prop({ type: String, required: true })
    icon!: string;

    public setIsSmall(small: boolean): void {
        this.isSmall = small;
    }

    private lightGallery(): void {
        const customWindow = window as unknown as CustomWindow;
        customWindow.lightGallery(this.$refs.lightGallery, {
            selector: '.light-gallery__image',
            progressBar: false,
        });
    }

    private mounted(): void {
        this.lightGallery();
    }

    private changeDetailsState(): void {
        this.setIsSmall(!this.isSmall);
    }
}
